/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import FileItemPreview from './FileItemPreview';
import TrashCan from '../../../common/icons/TrashCan';

import { getFileType } from '../utils/multimediaFormHelpers';
import { fileNameLength } from '../../helpers/crosspostCheckoutConstants';

const FileItem = ({
  fileName,
  thumbnailUrl = '',
  caption,
  mmAddOnMediaType = '',
  removeFile,
  updateCaption,
  submitCaption,
}) => {
  // If fileName length is > fileNameLength characters, return truncated
  // fileName with ellipsis added; otherwise return original fileName.
  const truncatedFileName = fileName.length > fileNameLength ? `${fileName.substring(0, fileNameLength)}...` : fileName;
  const fileType = mmAddOnMediaType === 'embedded_video' ? 'embedded_video' : getFileType(fileName);
  const inputText = 'Caption and credit';

  return (
    <>
      <div className="file-item">
        <FileItemPreview
          containerClass="thumbnail-container"
          fileType={fileType}
          thumbnailUrl={thumbnailUrl}
          thumbnailClass="thumbnail-container__thumbnail"
        />
        <div className="file-item__details">
          <div className="file-item__header">
            <span className="file-item__header__name">{fileName}</span>
            <span
              className="file-item__header__remove-button"
              onClick={() => removeFile()}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  removeFile();
                }
              }}
              aria-label={`Delete ${truncatedFileName}`}
              role="button"
              tabIndex="0"
            >
              <TrashCan />
            </span>
          </div>
          <input
            type="text"
            className="file-item__caption"
            name={fileName}
            onChange={updateCaption}
            onBlur={submitCaption}
            placeholder={inputText}
            value={caption}
          />
        </div>
      </div>
    </>
  );
};

FileItem.propTypes = {
  fileName: PropTypes.string.isRequired,
  thumbnailUrl: PropTypes.string,
  caption: PropTypes.string.isRequired,
  mmAddOnMediaType: PropTypes.string,
  removeFile: PropTypes.func.isRequired,
  updateCaption: PropTypes.func.isRequired,
  submitCaption: PropTypes.func.isRequired,
};

export default FileItem;
